var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("LfLabelButtonComponent", {
    attrs: {
      text: _vm.buttonText,
      variant: _vm.variant,
      size: _vm.size,
      action: _vm.openUrl,
      clickOnce: false,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }